import "$styles/index.css"
import "$styles/syntax-highlighting.css"
import "./contact_form.js"

// Import all JavaScript & CSS files from src/_components
import components from "$components/**/*.{js,jsx,js.rb,css}"

console.info("Bridgetown is loaded!")
